<template>
  <div class="content-details-section">
    <div v-if="!isMessage" class="data-title">campaign content</div>

    <div v-if="campaignItem" class="messages-content-section">
      <div v-if="campaignItem.template_image && haveClassicCampaignDisabledOrIsAutoConnectAndNotificationMmsEnabled" class="mms-content-section">
        <label>notification image</label>
        <div class="mms-sent-section">
          <img class="thumbnail"
              @click="setPreviewModal('showNotificationImageModal')"
              :src="campaignItem.template_image.attachment.thumb">
        </div>

        <div class="mms-content-expand" v-if="showNotificationImageModal">
          <image-preview-modal
            :modalConfig="modalConfig"
            :expandMMS="expandMMS"
            :imageSrc="campaignItem.template_image.attachment.url"
            @close="closeModal('showNotificationImageModal')">
          </image-preview-modal>
        </div>
      </div>

      <div v-if="campaignItem.template_content" class="mms-content-section template-content">
        <label v-if="!isMessage">text message</label>
        <div class="callout message complete-sms-content">
          <div v-if="campaignItem.classic_campaign">{{campaignItem.classic_sms_content}}</div>
          <div v-if="!campaignItem.classic_campaign">{{campaignItem.template_content}}</div>
        </div>
      </div>

      <div v-if="campaignItem.is_email_campaign" class="email-content-section">
        <label>email subject</label>
        <div class="callout message email-subject">{{campaignItem.email_subject}}</div>

        <label>email message</label>
        <image-preview-modal
            v-if="showEmailPreviewImageModal"
            :modalConfig="modalConfig"
            :expandMMS="expandMMS"
            :imageSrc="campaignItem.email_preview_image"
            @close="closeModal('showEmailPreviewImageModal')">
        </image-preview-modal>
        <img :src="campaignItem.email_preview_image"
              class="email-image-preview"
              @click="setPreviewModal('showEmailPreviewImageModal')"
              alt="email preview"
        />
      </div>
    </div>

    <div v-if="campaignItem && !campaignItem.classic_campaign" class="data-title">stashboard content</div>
    <div v-if="campaignItem && !campaignItem.classic_campaign" class="messages-content-section stashboard">
      <div v-if="campaignItem.mms && campaignItem.mms.length" class="mms-content-section">
          <label>mms (as {{campaignItem.image_type}})</label>
          <div class="mms-sent-section">
            <img v-for="mms in campaignItem.mms"
                class="thumbnail"
                @click="setPreviewModal('showModal')"
                :key="mms"
                :src="mms">
          </div>

        <div class="mms-content-expand" v-if="showModal">
          <image-preview-modal
            :modalConfig="modalConfig"
            :alt="campaignItem.mms"
            :imageSrc="campaignItem.mms"
            :expandMMS="expandMMS"
            @close="closeModal('showModal')">
          </image-preview-modal>
        </div>
      </div>
      <div v-if="campaignItem.audio && campaignItem.audio.length" class="mms-content-section">
        <label>voice text</label>
        <div class="audio-sent-section">
          <media-playback v-for="audio in campaignItem.audio"
                          :key="audio"
                          :attachedMedia="{ url: audio }"
                          :mediaPlayerOptions="mediaPlayerOptions"></media-playback>
        </div>
      </div>

      <div v-if="showBrands && campaignItem.has_ad" class="mms-content-section">
        <label>sponsored image (as {{campaignItem.image_type}})</label>
        <div class="mms-sent-section">
          <img v-if="campaignItem.has_watermarked_image" class="thumbnail" @click="setPreviewModal('showAdModal')" :src="campaignItem.ad_image">
          <div v-else>--processing--</div>
        </div>
      </div>

      <div class="mms-content-expand" v-if="showAdModal">
        <image-preview-modal
          :modalConfig="modalConfig"
          :alt="campaignItem.ad_image"
          :imageSrc="campaignItem.ad_image"
          :expandMMS="expandMMS"
          @close="closeModal('showAdModal')">
        </image-preview-modal>
      </div>
      <div v-if="campaignItem.is_sms_campaign || isMessage" class="sms-content-section">
        <div class="callout message complete-sms-content">{{campaignItem.sms_content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import MediaPlayback from '../MediaAttachments/MediaPlayback'
  import ImagePreviewModal from '../shared/ImagePreviewModal'

  export default {
    props: {
      campaignItem: Object,
      isMessage: Boolean,
      isTracked: Boolean,
    },

    name: 'ContentSection',

    components: {
      MediaPlayback,
      ImagePreviewModal,
    },

    data() {
      return {
        expandMMS: true,
        groupsWithSelected: null,
        mediaPlayerOptions: {
          barRadius: 4,
          barWidth: 10,
        },
        merchantSegmentIds: null,
        modalConfig: {},
        selectedGroups: null,
        showModal: false,
        showAdModal: false,
        showEmailPreviewImageModal: false,
        showNotificationImageModal: false
      }
    },

    methods: {
      closeModal(modalTypeShow) {
        this[modalTypeShow] = false
      },

      setPreviewModal(modalTypeShow) {
        this.modalConfig = {
          showClose: true,
          wrapperClasses: 'image-preview-modal',
        }
        this[modalTypeShow] = true
      }
    },

    computed: {
      haveClassicCampaignDisabledOrIsAutoConnectAndNotificationMmsEnabled(){
        return (!this.classicCampaignsEnabled || this.isMessage) && this.hasNotificationMmsMetaEnabled
      },

      ...mapGetters([
        'classicCampaignsEnabled',
        'hasNotificationMmsMetaEnabled',
        'showBrands',
      ]),

      ...mapState([
        'currentMerchant'
      ])
    }
  }
</script>

<style scoped>
.email-image-preview {
  height: auto;
  width: 200px;
  margin-bottom: 16px;
}
</style>
